"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormControlPlainText = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledBaseComponents = require("styled-base-components");

var _styledConfig = require("styled-config");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding-top: ", ";\n  padding-bottom: ", ";\n  margin-bottom: ", ";\n  line-height: 1.5;\n  background-color: ", ";\n  border: solid ", ";\n  border-width: 1px 0;\n  box-sizing: border-box;\n  ", ";\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    padding-right: ", ";\n    padding-left: ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      display: inline-block;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var display = function display(props) {
  if (props.inline) {
    return (0, _styledComponents.css)(_templateObject());
  }

  return (0, _styledComponents.css)(_templateObject2());
};

var padding = function padding(props) {
  return (props.sm || props.lg) && (0, _styledComponents.css)(_templateObject3(), (0, _styledConfig.getPadding)(props, 'formControlPlainText', 'smRight'), (0, _styledConfig.getPadding)(props, 'formControlPlainText', 'smLeft'));
};

var FormControlPlainText = (0, _styledComponents["default"])(_styledBaseComponents.Input)(_templateObject4(), function (props) {
  return (0, _styledConfig.getPadding)(props, 'formControlPlainText', 'top');
}, function (props) {
  return (0, _styledConfig.getPadding)(props, 'formControlPlainText', 'bottom');
}, function (props) {
  return (0, _styledConfig.getMargin)(props, 'formControlPlainText', 'bottom');
}, function (props) {
  return (0, _styledConfig.getColor)(props, 'formControlPlainText', 'backgroundColor');
}, function (props) {
  return (0, _styledConfig.getColor)(props, 'formControlPlainText', 'borderColor');
}, function (props) {
  return display(props);
}, function (props) {
  return padding(props);
});
exports.FormControlPlainText = FormControlPlainText;
FormControlPlainText.defaultProps = {
  theme: _styledConfig.theme
};